import { migrationCanvasSelectors } from '@store/migrationSelectors/canvasSelectors'
import type React from 'react'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { useArtboardMode } from '@/hooks'
import { ArrowLabels, Arrows } from '../Arrows'
import GestureListener from '../GestureListener/GestureListener'
import { NewThreadContainer } from '../Threads'
import Tree from '../Tree/Tree'
import css from './Canvas.module.scss'
import { ELEMENT_GESTURE_MOVABLE_CONTAINER } from './hooks/events/useDragEvents'

const Canvas: React.FC = () => {
  const gestureListenerContainerRef = useRef(null)
  const movableContainerRef = useRef(null)

  const { gallery, seoMode, newThread } = useArtboardMode()
  const showArrows = !gallery && !seoMode

  const selectedArrow = useSelector(
    migrationCanvasSelectors.getSelectedArrowForCanvas
  )

  useEffect(() => {
    // Without this hack PDF export does not contain arrows
    const printedNode = document.getElementById('printed-node') as HTMLElement

    if (printedNode) {
      printedNode.style.position = selectedArrow ? 'relative' : 'initial'
    }
  }, [selectedArrow])

  return (
    <div className={css.container} id="artboard">
      <GestureListener
        gestureListenerContainerRef={gestureListenerContainerRef}
        movableContainerRef={movableContainerRef}
      >
        <div
          className={css.movableContainer}
          id={ELEMENT_GESTURE_MOVABLE_CONTAINER}
          ref={movableContainerRef}
        >
          <div id="printed-node" className={css.printContainer}>
            {showArrows && <Arrows />}

            <Tree />

            {showArrows && <ArrowLabels />}
          </div>
        </div>
        {newThread && <NewThreadContainer />}
      </GestureListener>
    </div>
  )
}

export default Canvas
